import axios from 'axios';
import store from '@/store';
import i18n from '@/lang';

import Message from '@/components/message/message';
let msgBox = Message.install;

export default function $axios(options) {
	return new Promise((resolve, reject)=>{
		// 创建axios 实例
		const service = axios.create({
			baseURL:options.url.indexOf('/static/') > -1 ? '' :process.env.BASE_API,
			timeout:10000, // 请求超时时间
		});

		// request 拦截器
		service.interceptors.request.use(
			config=>{
				// 这里可以自定义一些config 配置
				// loading + 1
				store.dispatch('SetLoading', true);
				return config;
			},
			error=>{
				//  这里处理一些请求出错的情况
				// loading 清 0
				setTimeout(function() {
					store.dispatch('SetLoading', 0);
				}, 300);

				if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
					msgBox({
						// content:'TIMEOUT',
						content:i18n.vm.messages[i18n.locale]['BACKENDMSG']['TIMEOUT'],
						timeOut:2000,
						isClose:false,
						type:'error',
					});
					// return service.request(originalRequest);// 再重复请求一次
				}
				
				Promise.reject(error);
			}
		);

		// response 拦截器
		service.interceptors.response.use(
			response=>{
				const res = response.data;
				store.dispatch('SetBackendMsgType',res.msgType);
				store.dispatch('SetBackendMsg',res.msg);

				setTimeout(function(){
					store.dispatch('SetLoading', false);
				},300);

				if(res.msgType!=='' && res.msg){
					if(options.noAxiosTips!==true){
						msgBox({
							// content:res.msg,
							content:i18n.vm.messages[i18n.locale]['BACKENDMSG'][res.msg],
							timeOut:2000,
							isClose:false,
							type:res.msgType,
						});
					}
				}

				return res;
			},
			error=>{
				// 这里处理一些response 出错时的逻辑

				// loading - 1
				setTimeout(function(){
					store.dispatch('SetLoading', false);
				},300);

				msgBox({
					// content:'UNKNOW_ERROR',
					content:i18n.vm.messages[i18n.locale]['BACKENDMSG']['UNKNOW_ERROR'],
					timeOut:2000,
					isClose:false,
					type:'error',
				});

				return Promise.reject(error);
			}
		);

		// 请求处理
		service(options).then(res=>{
			resolve(res)
			return false
		}).catch(error=>{
			reject(error)
		})
	})
}



// WEBPACK FOOTER //
// ./src/provider/axios.js